import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Facebook: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] fill-black text-white', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_632_7400)">
      <path
        d="M24 12.0002C24 5.37282 18.6274 0.000244141 12 0.000244141C5.37258 0.000244141 0 5.37282 0 12.0002C0 17.9897 4.3882 22.9542 10.125 23.8545V15.469H7.07812V12.0002H10.125V9.35649C10.125 6.34899 11.9166 4.68774 14.6576 4.68774C15.9701 4.68774 17.3438 4.92212 17.3438 4.92212V7.87524H15.8306C14.34 7.87524 13.875 8.80032 13.875 9.75024V12.0002H17.2031L16.6711 15.469H13.875V23.8545C19.6118 22.9542 24 17.9897 24 12.0002Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_632_7400">
        <rect width="24" height="24" fill="currentFill" transform="translate(0 0.000244141)" />
      </clipPath>
    </defs>
  </svg>
);

export default Facebook;
